import { Link } from 'react-router-dom'

import { cn } from 'utils/cn'

import { Logo } from './Logo'

import type { FC, PropsWithChildren } from 'react'

type Props = {
  menu?: React.ReactNode
  title?: string | null
}

export const MobileHeader: FC<PropsWithChildren<Props>> = ({ children, menu, title }) => (
  <div className="flex h-13 w-full items-center justify-between pl-4 lg:hidden">
    {menu}

    {title
      ? (
          <h1 className="truncate px-4 text-base font-medium" title={title}>
            {title}
          </h1>
        )
      : (
          <div className={cn('flex shrink-0 h-6', { 'px-4 ml-4': menu })}>
            <Link to="/">
              <Logo />
            </Link>
          </div>
        )}

    <div className="mx-4 flex items-center justify-center">
      {children}
    </div>
  </div>
)
